export const TelescopeCode = {};

export const patientPlanStatus = {
  WAIT_ACCEPT: {
    text: '待接受',
    color: '#FFF2F3',
    textColor: '#FF002C',
  },
  EXECUTING: {
    text: '执行中',
    color: '#EBF8FF',
    textColor: '#1E8DFF',
  },
  WAIT_DOCTOR_AUDIT: {
    text: '待医生审核',
    color: '#FFF6EA',
    textColor: '#D48806',
  },
  FINISHED: {
    text: '已结束',
    color: '#FFF6EA',
    textColor: '#D48806',
  },
};
